module.exports = __webpack_public_path__ + "static/media/RegisteredEmpty.9a4a4881.svg";